//  React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

function Footer() {
  return (
    <VuiBox
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      direction="row"
      component="footer"
      py={2}
      pb={0}
    >
      <VuiBox item xs={12} sx={{ textAlign: "center" }}>
        <VuiTypography
          variant="button"
          sx={{ textAlign: "center", fontWeight: "400 !important" }}
          color="white"
        >
          @ 2025, Made by{" "}
          <VuiTypography
            component="a"
            variant="button"
            href="https://www.batchingandblending.com/"
            sx={{ textAlign: "center", fontWeight: "500 !important" }}
            color="text"
            mr="2px"
          >
            Batching and Blending
          </VuiTypography>
        </VuiTypography>
      </VuiBox>
    </VuiBox>
  );
}

export default Footer;
